export default __webpack_public_path__ + "media/images/logos/construction-logo-a946b45330a868ba1c1086079688c949.png";